import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "./../../utils/Modal";
import Swal from "sweetalert2";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const PopupList = (props) => {
  const {
    popups,
    index,
    loadingCallback,
    setSuccessFlashMessage,
    setPayment,
    getPopupList,
    navigate,
    brands
  } = props;

  const token = localStorage.getItem("token");
  const [showPopupViewModal, setShowPopupViewModal] = useState(false);
  const [popup, setPopup] = useState("");
  const [showPopupEditModal, setShowPopupEditModal] = useState(false);

  const handlePopupViewOpen = (id, popup) => {
    getPopupView(id);
    setPopup(popup);
  };

  const getPopupView = (id) => {
    setShowPopupViewModal(true);
  };

  const handlePopupEditOpen = (popup) => {
    setPopup(popup);
    setShowPopupEditModal(true);
  };

  const showModalBeforeDelete = (id, index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id);
      }
    });
  };

  const handleDelete = (id) => {
    axios
      .delete(`${process.env.REACT_APP_API_URL}popups/${id}`, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.data.success) {
          getPopupList();
          notify("Popup deleted successfully", "success");
        }
      })
      .catch((error) => {
        console.error(
          "Error deleting offer:",
          error.response?.data || error.message
        );

        // Handle unauthorized errors (e.g., token expired)
        if (error.response?.status === 401) {
          localStorage.clear();
          localStorage.setItem("token", false);
          localStorage.setItem("isPinVerify", false);
          navigate("/login");
        } else {
          notify("Failed to delete Popup. Please try again.", "error");
        }
      });
  };

    const notify = (msg, type) => {
      if (type == "success") {
        toast.success(msg, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          style: { zIndex: 9999 },
        });
      }
      if (type == "error") {
        toast.error(msg, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          style: { zIndex: 9999 },
        });
      }
    };

    return (
      <>
        <div>
          {console.log("list",brands)}
          <div
            key={index}
            className="grid grid-cols-5 md:gap-5  gap-2 items-center font-nunito font-[500] text-[14px] text-[#000232] border-t-[1px] border-solid border-[#E7EBF4] py-[8px]"
          >
            {/* <div className="border-t-[1px] border-solid border-[#E7EBF4] py-[8px] font-nunito font-[500] text-[#000232] grid grid-cols-7 items-start"> */}
            <div>
              <div className="">
                {/* <div className="font-nunito text-[14px]"> */}
                <div className="font-[500] text-[#000232]">#{index + 1}</div>
                <div className="font-[700] text-[#87889E]">{popups.title}</div>
                {/* </div> */}
              </div>
            </div>
            {/* <div className="text-center">{popups.catogory_name}</div> */}
            <div className="text-center"> {brands.find((brand) => brand.id === popups.brand_id)?.name || "N/A"}</div>
            <div className="text-center">
              {new Date(popups.created_at).toISOString().split("T")[0]}
            </div>
            <div className="text-center">
              {new Date(popups.updated_at).toISOString().split("T")[0]}
            </div>
            <div className="flex gap-2  text-xs justify-end">
              <label
                htmlFor="view_offer_modal"
                // onClick={()=>setShowViewModal(val=>!val)}
                //onClick={()=> Swal.fire("View option coming soon")}
                onClick={() => handlePopupViewOpen(popups?.id, popups)}
                className="cursor-pointer border-[1px] border-solid border-[#407BFF] text-[#407BFF] rounded-[5px] px-[6px] py-1"
              >
                VIEW
              </label>
              <label
                htmlFor="edit_offer_modal"
                //onClick={()=> Swal.fire("Edit option coming soon")}
                onClick={() => handlePopupEditOpen(popups)}
                className="cursor-pointer border-[1px] border-solid bg-[#407BFF] border-[#407BFF] text-white rounded-[5px] px-[7px] py-1"
              >
                EDIT
              </label>
              <label
                // htmlFor="editAccTxn_modal"
                // onClick={()=> Swal.fire("Edit option coming soon")}
                onClick={() => showModalBeforeDelete(popups?.id)}
                className="cursor-pointer border-[1px] border-solid bg-[#FF0303] text-white rounded-[5px] px-[7px] py-1"
              >
                DELETE
              </label>
            </div>
          </div>
        </div>

        {showPopupViewModal ? (
          <Modal
            isOpen={showPopupViewModal}
            setOpen={setShowPopupViewModal}
            title="Popup Details"
            formId="viewPopupModal"
            loadingCallback={loadingCallback}
            type="viewPopupModal"
            popup={popup}
            brands={brands}
          />
        ) : null}

        {showPopupEditModal ? (
          <Modal
            isOpen={showPopupEditModal}
            setOpen={setShowPopupEditModal}
            title="Edit popup"
            formId="edit_popup_modal"
            type="edit_popup_modal"
            popup={popup}
            notify={notify}
            getPopupList={getPopupList}
            brands={brands}
          />
        ) : null}
      </>
    );
};

export default PopupList;
